module.exports = __webpack_public_path__ + "img/tokyo_24.a0ebe0b6.png";